query MfaSessions(
	$offset: Int!
	$limit: Int!
	$sort: mfa_session_runsSort
	$textSearch: mfa_session_runsSearchInsensitive
	$textSearchExact: mfa_session_runsSearchInsensitive
	$daysAmountFilter: ConditionInt
	$createdByFilter: ConditionString
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionStringArray
	$appFilter: ConditionStringArray
	$appVersionFilter: ConditionStringArray
	$criticalIssuesFilter: ConditionInt
	$seriousIssuesFilter: ConditionInt
	$moderateIssuesFilter: ConditionInt
	$minorIssuesFilter: ConditionInt
	$bestPracticeIssuesFilter: ConditionInt
	$needsReviewIssuesFilter: ConditionInt
) {
	mfa_session_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
		critical_issues_gt: $criticalIssuesFilter
		serious_issues_gt: $seriousIssuesFilter
		moderate_issues_gt: $moderateIssuesFilter
		minor_issues_gt: $minorIssuesFilter
		best_practice_issues_gt: $bestPracticeIssuesFilter
		needs_review_issues_gt: $needsReviewIssuesFilter
	) {
		run_id
		session_name
		total_scans
		total_issues
		critical_issues
		serious_issues
		moderate_issues
		minor_issues
		best_practice_issues
		needs_review_issues
		run_time
		user_name
		custom_fields
		app
		app_version
		os
	}
	total: mfa_session_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
		critical_issues_gt: $criticalIssuesFilter
		serious_issues_gt: $seriousIssuesFilter
		moderate_issues_gt: $moderateIssuesFilter
		minor_issues_gt: $minorIssuesFilter
		best_practice_issues_gt: $bestPracticeIssuesFilter
		needs_review_issues_gt: $needsReviewIssuesFilter
	) {
		run_id_count
	}
	unfiltered_total: mfa_session_runs {
		run_id_count
	}
}
